import { useParams } from "react-router";

const useFinal = () => {
    // Params
    const { number } = useParams();

    const array = [];

    for(let i = 0; i < parseInt(number); i++){
        array.push(
            <div className={`coraz${i}`} >
                <img src="/images/corazon.png" alt="corazon" />
            </div>
        )
    }

    return {
        array
    }
}

export default useFinal;